import { Box, Button, Paper, Typography, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SignalRContext } from "../../components/SignalR/SignalRProvider";
import { LanguageChangeNoAuth } from "../../components/UI/LanguageChangeNoAuth/LanguageChangeNoAuth";
import { PlatformFooter } from "../../components/UI/PlatformFooter/PlatformFooter";
import { removeTotemDevice } from "../../services/totemDevide.service";
import { useAppSelector } from "../../store/store";
import { colors } from "../TotemStart/TotemStart";

const translationPath = "page.mainMenu.";

function MainMenu() {
  const { t } = useTranslation();

  const theme = useTheme();

  const [counter, setCounter] = useState(1);

  const [showTicket, setShowTicket] = useState(false);

  const [senhaNumero, setSenhaNumero] = useState("");

  const navigate = useNavigate();

  SignalRContext.useSignalREffect(
    "TotemDeviceSessionLogout",
    (data: string) => {
      removeTotemDevice();
      localStorage.removeItem("browserId");
      navigate("/totem-start");
    },

    []
  );

  const generatePasswordHandler = useCallback(async () => {
    setShowTicket(true);
    const novaSenha = `Senha ${counter.toString().padStart(3, "0")}`;
    setSenhaNumero(novaSenha);
    setCounter((prev) => prev + 1);

    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowTicket(false);
      }, 500);
    }, 500);
  }, [counter]);

  const handleCheckIn = () => {
    alert("Função de Check-in (exemplo).");
  };

  const scheduleHandler = () => {
    alert("Função de Agendamento (exemplo).");
  };

  const { logo, logoLogin, logo_dark, mode, name } = useAppSelector(
    (state) => state.theme
  );

  const totemLogo = logoLogin
    ? logoLogin
    : mode === "1"
    ? logo
    : logo_dark
    ? logo_dark
    : logo;

  return (
    <Box
      sx={(t) => ({
        p: 4,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: t.palette.grey[t.palette.mode === "light" ? 50 : 900],
      })}
    >
      {!showTicket && (
        <>
          <Paper
            sx={{
              p: { xs: 3, sm: 5 },
              width: "90%",
              height: "80vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 4,
              boxShadow: 6,
              position: "relative",
            }}
          >
            <LanguageChangeNoAuth colors={colors} />
            <img
              src={totemLogo}
              alt={name}
              style={{ width: "350px", height: "auto" }}
            />
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3 }}>
              {t(translationPath + "welcome")}
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 18, mb: 2 }}>
              {t(translationPath + "need_help")}
            </Typography>
            <Button
              onClick={generatePasswordHandler}
              variant="contained"
              sx={{
                px: 4,
                py: 2,
                mb: 4,
                fontSize: 18,
                fontWeight: "bold",
                color: "#fff",
                borderRadius: 5,
              }}
            >
              {t(translationPath + "password_button")}
            </Button>

            <Typography variant="body1" sx={{ fontSize: 18, mb: 3 }}>
              {t(translationPath + "can_do_it")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                justifyContent: "center",
              }}
            >
              <Button
                onClick={handleCheckIn}
                variant="contained"
                sx={{
                  px: 3,
                  py: 2,
                  fontSize: 18,
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  color: "#fff",
                  borderRadius: 5,
                }}
              >
                {t(translationPath + "check_in_button")}
              </Button>
              <Button
                onClick={scheduleHandler}
                variant="contained"
                sx={{
                  px: 3,
                  py: 2,
                  borderRadius: 5,
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#fff",
                }}
              >
                {t(translationPath + "schedule_button")}
              </Button>
            </Box>
          </Paper>

          <PlatformFooter width={"90%"} color={theme.palette.primary.main} />
        </>
      )}

      {showTicket && (
        <Box
          id="senhaContainer"
          sx={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <Box
            sx={{
              p: 3,
              width: 350,
              height: 350,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 4,
              boxShadow: 4,
              backgroundColor: "#fff",
            }}
          >
            <Typography sx={{ fontSize: 18, fontWeight: "bold", mb: 2 }}>
              {t(translationPath + "totem")}
            </Typography>
            <Typography
              sx={{ fontSize: 36, fontWeight: "bold", mb: 2 }}
              id="senhaNumero"
            >
              {senhaNumero}
            </Typography>
            <Typography sx={{ fontSize: 14 }}>
              {t(translationPath + "thanks")}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default MainMenu;
